export const RIcon = ({ className, width = "44", height = "44", style }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <rect width="44" height="44" rx="22" fill="#FDFDFD" />
      <path
        d="M22 35.125C25.481 35.125 28.8194 33.7422 31.2808 31.2808C33.7422 28.8194 35.125 25.481 35.125 22C35.125 18.519 33.7422 15.1806 31.2808 12.7192C28.8194 10.2578 25.481 8.875 22 8.875C18.519 8.875 15.1806 10.2578 12.7192 12.7192C10.2578 15.1806 8.875 18.519 8.875 22C8.875 25.481 10.2578 28.8194 12.7192 31.2808C15.1806 33.7422 18.519 35.125 22 35.125ZM17.0781 16.668C17.0781 15.9861 17.6267 15.4375 18.3086 15.4375H22.8203C25.0864 15.4375 26.9219 17.2729 26.9219 19.5391C26.9219 20.9746 26.1836 22.241 25.0608 22.9741L26.8091 26.8245C27.0911 27.4448 26.8142 28.1729 26.199 28.4548C25.5837 28.7368 24.8506 28.46 24.5686 27.8447L22.6614 23.6406H19.5391V27.332C19.5391 28.0139 18.9905 28.5625 18.3086 28.5625C17.6267 28.5625 17.0781 28.0139 17.0781 27.332V22.4102V16.668ZM19.5391 21.1797H22.8203C23.7278 21.1797 24.4609 20.4465 24.4609 19.5391C24.4609 18.6316 23.7278 17.8984 22.8203 17.8984H19.5391V21.1797Z"
        fill="url(#paint0_linear_6106_1083)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6106_1083"
          x1="43.5833"
          y1="3.82027"
          x2="7.88558"
          y2="51.3034"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE195" />
          <stop offset="1" stopColor="#FAAD2A" />
        </linearGradient>
        <clipPath id="clip0_6106_1083">
          <rect fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};
